module.exports = __webpack_public_path__ + "static/media/airplane.d99d6f1b.png";